import awsExports from "../stack-exports.json";

export type Env = {
  stage: string;
  outputs: {
    DatabaseURL: string;
    ApiUrl: string;
    UserPoolId: string;
    ApiLambdaFunctionQualifiedArn: string;
    Stage: string;
    Region: string;
    ClientId: string;
    ServerlessDeploymentBucketName: string;
    PostUserConfirmationHookLambdaFunctionQualifiedArn: string;
  };
  host: {
    fullyQualifiedUrl: string;
    domain: string;
  };
  stripePublicKey?: string;
  dashboardURL: string;
  intercomAppId?: string;
};

/**
 * Env override for custom environment
 */
const env =
  process.env.REACT_APP_NODE_ENV_OVERRIDE ||
  process.env.NODE_ENV ||
  "development";

const stage = process.env.REACT_APP_STAGE;
const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
const intercomAppId = process.env.REACT_APP_INTERCOM_APP_ID
  ? process.env.REACT_APP_INTERCOM_APP_ID
  : stage === "production"
  ? "t8qfmn5l"
  : "ibragaxm";

// @ts-ignore
const config: Env = awsExports[stage];
const fullyQualifiedUrl = window.location.origin;

const domainRegex = new RegExp("([a-z-0-9]{2,63}).([a-z.]{2,5})$");
const domainParsed = domainRegex.exec(window.location.hostname);
const domain = domainParsed ? domainParsed[0] : window.location.hostname;

config.dashboardURL =
  process.env.REACT_APP_DASHBOARD_URL || "https://dashboard.ilivestock.co.uk";

if (env !== "production") {
  console.group("Environment");
  console.debug("Config: ", config);
  console.groupEnd();
}

export const environment: Env = {
  ...config,
  host: {
    domain,
    fullyQualifiedUrl,
  },
  stripePublicKey,
  intercomAppId,
};
